import React from 'react';
import GoogleDriveFolderBrowser from './GoogleDriveFolderBrowser';
import Icon from '../../../components/AppIcon';

const GoogleDriveStep = ({ formData, onChange, errors }) => {
  const handleFolderSelect = (folderType, folderId, folderName) => {
    onChange('selectedFolders', {
      ...formData?.selectedFolders,
      [folderType]: folderId,
      [`${folderType}Name`]: folderName
    });
  };

  return (
    <div className="space-y-4 md:space-y-6">
      <div className="bg-card border border-border rounded-xl p-4 md:p-6">
        <div className="flex items-start gap-3 mb-4 md:mb-6">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="HardDrive" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-lg md:text-xl font-semibold">Google Drive Integration</h3>
            <p className="text-sm md:text-base text-muted-foreground mt-1">
              Connect your Google Drive folders to automatically populate the gallery with media files
            </p>
          </div>
        </div>

        <div className="space-y-6 md:space-y-8">
          <GoogleDriveFolderBrowser
            selectedFolders={formData?.selectedFolders}
            onFolderSelect={handleFolderSelect}
            folderType="highRes"
          />

          <div className="border-t border-border pt-6" />

          <GoogleDriveFolderBrowser
            selectedFolders={formData?.selectedFolders}
            onFolderSelect={handleFolderSelect}
            folderType="compressed"
          />
        </div>

        {errors?.selectedFolders && (
          <div className="mt-4 p-3 bg-destructive/10 border border-destructive rounded-lg flex items-start gap-2">
            <Icon name="AlertCircle" size={16} color="var(--color-destructive)" className="flex-shrink-0 mt-0.5" />
            <span className="text-sm text-destructive">{errors?.selectedFolders}</span>
          </div>
        )}
      </div>
      <div className="bg-accent/10 border border-accent rounded-xl p-4 md:p-5">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
          <div className="space-y-2">
            <p className="text-sm md:text-base font-medium">Important Notes:</p>
            <ul className="text-xs md:text-sm text-muted-foreground space-y-1 list-disc list-inside">
              <li>Ensure folders have proper sharing permissions</li>
              <li>High-resolution folder should contain original quality files</li>
              <li>Compressed folder should contain web-optimized versions</li>
              <li>Gallery will automatically sync with folder contents</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoogleDriveStep;